import type { paths as MarketplaceRequests, components as MarketplaceTypes } from '~/types/api/marketplace-api-types'
import type { components as PlacesTypes } from '~/types/api/places-api-types'
import type { components as GisTypes } from '~/types/api/gis-api-types'

export type LeadBuyerRequest =
  MarketplaceTypes['schemas']['Rvezy.Marketplace.Api.Dtos.Request.CreateBuyerLeadRequest']

export type Rv = MarketplaceTypes['schemas']['Rvezy.Marketplace.Api.Dtos.Response.RvResponse']
export type PlaceSeo = MarketplaceTypes['schemas']['Rvezy.Marketplace.Api.Dtos.Response.PlaceSeoResponse']
export type PlaceFaq = MarketplaceTypes['schemas']['Rvezy.Marketplace.Api.Dtos.Response.PlaceFaqResponse']

export type RvSearchRequest = NonNullable<MarketplaceRequests['/Rv/Search']['get']['parameters']['query']>

export type RvTypes = NonNullable<Rv['class']>
export const RvTypesList = [
  'Other',
  'OtherKnown',
  'ClassA',
  'ClassB',
  'ClassC',
  'TruckCamper',
  'FifthWheel',
  'TravelTrailer',
  'TentTrailer',
  'Hybrid',
  'ToyHauler',
  'MicroTrailer',
  'TinyHome',
  'ParkModel'
] as RvTypes[]
export const RvTypesGuard = (rvType: string) => RvTypesList.includes(rvType as RvTypes)

export type ListingConditions = NonNullable<Rv['listingCondition']>
export const ListingConditionsList = ['New', 'Used'] as ListingConditions[]
export const ListingConditionsGuard = (listingCondition: string) =>
  ListingConditionsList.includes(listingCondition as ListingConditions)

export type PurchaseRvConditions = NonNullable<LeadBuyerRequest['rvCondition']>
export const PurchaseRvConditionsList: PurchaseRvConditions[] = ['New', 'Used', 'Both']
export const PurchaseRvConditionsGuard = (rvCondition: string) =>
  PurchaseRvConditionsList.includes(rvCondition as PurchaseRvConditions)

export type MonthlyBudgets = NonNullable<LeadBuyerRequest['monthlyBudget']>
export const MonthBudgetsList: MonthlyBudgets[] = [
  'LessThan250',
  'Between250And500',
  'Between500And750',
  'Between750And1000',
  'GreaterThan1000',
  'Unknown'
]
export const MonthlyBudgetsGuard = (monthlyBudget: string) => MonthBudgetsList.includes(monthlyBudget as MonthlyBudgets)

export type PriceRanges = NonNullable<LeadBuyerRequest['priceRange']>
export const PriceRangesList: PriceRanges[] = [
  'Below25k',
  'Between25kAnd50k',
  'Between50kAnd100k',
  'GreaterThan100k',
  'Unknown'
]
export const PriceRangesGuard = (priceRange: string) => PriceRangesList.includes(priceRange as PriceRanges)

export type CreditScoreRanges = NonNullable<LeadBuyerRequest['creditScoreRange']>
export const CreditScoreRangesList: CreditScoreRanges[] = ['VeryGood', 'Good', 'Fair', 'Poor', 'Unknown']
export const CreditScoreRangesGuard = (creditScoreRange: string) =>
  CreditScoreRangesList.includes(creditScoreRange as CreditScoreRanges)

export type PurchaseTimeframes = NonNullable<LeadBuyerRequest['purchaseTimeframe']>
export const PurchaseTimeframesList: PurchaseTimeframes[] = [
  'AsSoonAsPossible',
  'LessThan3Months',
  'Between3And6Months',
  'Between6And12Months',
  'GreaterThan12Months',
  'Unknown'
]
export const PurchaseTimeframesGuard = (purchaseTimeframe: string) =>
  PurchaseTimeframesList.includes(purchaseTimeframe as PurchaseTimeframes)

export type RvCategories = NonNullable<Rv['category']>
export const RvCategoriesList = ['Motorhome', 'Towable', 'Stationary', 'Other'] as RvCategories[]
export const RvCategoriesGuard = (rvCategory: string) => RvCategoriesList.includes(rvCategory as RvCategories)

export type LanguageCodes = NonNullable<
  MarketplaceTypes['schemas']['Rvezy.Marketplace.Api.Dtos.Request.CreateDealerRequest']['languageCode']
>
export type RvSearchSorts = NonNullable<RvSearchRequest['OrderBy']>

export type Place = PlacesTypes['schemas']['Rvezy.Places.Api.Dtos.Response.PlaceResponse']
export type PlaceAncestor = PlacesTypes['schemas']['Rvezy.Places.Api.Dtos.Response.PlaceAncestorResponse']

export type RegionCodes = NonNullable<Place['regionCode']>
export type CountryCodes = NonNullable<Place['countryCode']>

export type KeywordResponse = MarketplaceTypes['schemas']['Rvezy.Marketplace.Api.Dtos.Response.KeywordResponse']
export type FilterValueResponse = MarketplaceTypes['schemas']['Rvezy.Marketplace.Api.Dtos.Response.FilterValueResponse']
export type FilterValueRvClassResponse = MarketplaceTypes['schemas']['Rvezy.Marketplace.Api.Dtos.Response.FilterValueResponse']['filterRvClass']

export type RVezyGisGeocode = GisTypes['schemas']['Rvezy.GeographicInformationService.Models.Google.Maps.Geocode']
export type RVezyGisGeocodeAddressComponent =
  GisTypes['schemas']['Rvezy.GeographicInformationService.Models.Google.Maps.AddressComponent']
export type RVezyGisGeocodeLatLngLiteral =
  GisTypes['schemas']['Rvezy.GeographicInformationService.Models.Google.Maps.LatLngLiteral']
export type RVezyGisGeocodeBounds = GisTypes['schemas']['Rvezy.GeographicInformationService.Models.Google.Maps.Bounds']
export type RvezyGisPlace = GisTypes['schemas']['Rvezy.GeographicInformationService.Models.Google.Maps.Place']
export type RvezyGeoCodeResponse =
  GisTypes['schemas']['Rvezy.GeographicInformationService.Dtos.Response.GoogleGeocodingResponse']
export type RvezyPlaceResponse = GisTypes['schemas']['Rvezy.GeographicInformationService.Dtos.Response.GooglePlaceResponse']